import {
  AfterContentInit,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  EventEmitter,
  inject,
  Input,
  Output,
  QueryList,
  TemplateRef
} from '@angular/core';
import {TabBodyDirective} from '@shared/controls/tabs/tab-body.directive';
import {TabHeaderDirective} from '@shared/controls/tabs/tab-header.directive';
import * as uuid from 'uuid';

@Component({
  selector: 'pl-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['tabs.component.scss']
})
export class TabsComponent implements AfterContentInit {
  private lastHeaderIndex = 0;

  cdr = inject(ChangeDetectorRef);

  activeTabName = '';
  activeTemplate: TemplateRef<any>;

  @Input() initialTabName: string;
  @Input() tabPanedId = uuid.v4();

  @Output() tabchange = new EventEmitter<void>();

  @ContentChildren(TabHeaderDirective, {descendants: true}) headers: QueryList<TabHeaderDirective>;
  @ContentChildren(TabBodyDirective, {descendants: true}) bodies: QueryList<TabBodyDirective>;

  ngAfterContentInit() {
    // Tricking the Angular change detection
    setTimeout(() => {
      if (this.initialTabName) {
        this.activateTab(this.initialTabName);
      } else {
        this.activateFirstTab();
      }
    }, 10);
  }

  nextHeaderIndex() {
    return this.lastHeaderIndex++;
  }

  activateFirstTab() {
    this.activateTab(this.headers.first.bodyName, false);
  }

  activateTab(bodyName: string, emitChange = true) {
    this.activeTabName = bodyName;

    this.headers
      .forEach(h => {
        if (h.bodyName === bodyName) {
          h.setActive(true);
        } else {
          h.setActive(false);
        }
      });

    this.activeTemplate = this.bodies.find(body => body.name === bodyName).templateRef;
    this.cdr.detectChanges();

    if (emitChange) {
      setTimeout(() => this.tabchange.emit(), 10);
    }
  }

  focusActiveHeader() {
    this.headers.find(header => header.bodyName === this.activeTabName)?.focus();
  }
}
